import classes from './Modal.module.scss'
import { ItineraryActivity, ItineraryRestaurant } from '../../../atom/Types'
import React from 'react'
import Close from '@mui/icons-material/Close'
import { CalendarSvg, ClockSvg, CloseButtonSvg, DurationSvg, FlagSvg, WebSiteSvg } from '../../../constants/resources'
import moment from 'moment'
import { checkSpacing } from '../../../atom/utilities/function';
import Helper from '../../../Helper';

interface props {
    suggesionData?: ItineraryActivity | ItineraryRestaurant
    setSuggestedModal: React.Dispatch<React.SetStateAction<boolean>>
    handleSuggested: (node: ItineraryRestaurant | ItineraryActivity) => void
}

const ActRest: React.FC<props> = ({ suggesionData, setSuggestedModal, handleSuggested }) => {
    return (
        <div className={classes.ModalBackground}>
            <div className={classes.ModalContent}>
                <div className={classes.Flex}>
                    <div className={classes.ModalHead}>
                        <div className={suggesionData && suggesionData.type === 'Restaurant' && 'restaurant' in suggesionData && suggesionData.restaurant.website !== '' ? classes.website : classes.websiteDisabled} onClick={() => window.open(suggesionData && 'restaurant' in suggesionData ? suggesionData?.restaurant?.website : '')}>
                            Website
                            <WebSiteSvg />
                        </div>
                        <div>
                            <button className={classes.CloseButton} onClick={() => { setSuggestedModal(false) }}>
                                <Close className={classes.closesvg} />
                            </button>
                        </div>
                    </div>
                    <div className={classes.header}>{suggesionData && suggesionData.type === 'Restaurant' ? 'restaurant' in suggesionData && suggesionData?.restaurant?.name : suggesionData && 'activity' in suggesionData && suggesionData?.activity?.name}</div>

                    <hr />

                    <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: 'hidden' }}>

                        {suggesionData?.type === 'activity' ?
                            <div className={classes.content}>
                                <div className={classes.contentStruct}>
                                    <p className={classes.para}> Overview </p>

                                    {('activity' in suggesionData && suggesionData?.activity?.description) || checkSpacing(suggesionData?.comment) ?
                                        <>
                                            <div className={classes.comments}>{'activity' in suggesionData && suggesionData?.activity?.description}</div>
                                            <div id="eventMonitor" className={classes.comments} dangerouslySetInnerHTML={{ __html: suggesionData?.comment }} >
                                            </div>
                                        </>
                                        : <div className={classes.comments} style={{ fontStyle: 'italic', fontWeight: '100', opacity: '0.5' }}>no description found</div>}

                                    <p className={classes.para}> Cancellation Policy </p>
                                    {suggesionData?.cancellationPolicy || checkSpacing(suggesionData?.cancellationPolicy) ?
                                        <>
                                            <div id="eventMonitor" className={classes.comments} dangerouslySetInnerHTML={{ __html: suggesionData?.cancellationPolicy }} >
                                            </div>
                                        </>
                                        : <div className={classes.comments} style={{ fontStyle: 'italic', fontWeight: '100', opacity: '1', fontSize: '20px' }}>No cancellation policy available</div>}

                                </div>
                                <div className={classes.contentStruct}>
                                    <p className={classes.para}> Details </p>
                                    <div className={classes.internal}><CalendarSvg width={"16"} height={"16px"} color={"#273443"} /> Date : {moment.utc(suggesionData?.date).format('dddd, MMMM D, YYYY')} </div>
                                    <div className={classes.internal}><ClockSvg /> Start Time : {Helper.TimeConverter(suggesionData?.startTime)}</div>
                                    <div className={classes.internal}><DurationSvg /> Duration : {Helper.convertDecimalTime(suggesionData?.durationHours)} </div>
                                    <div className={classes.internal} style={{ alignItems: 'flex-start' }}><FlagSvg /> Meeting and Pickup : {'meetingPointInfo' in suggesionData && suggesionData?.meetingPointInfo}</div>

                                </div>
                                <div className={classes.bottomStruct}>
                                    <div className={classes.bottomGroup} style={{ gap: '30px' }}>
                                        {/* <div className={classes.bottomPrice}>
                                            <p style={{ fontSize: '12px', color: '#545D68' }}>Price Per Person</p>
                                            <p style={{ fontSize: '20px', color: '#273443' }}>$ {'netPrice' in suggesionData ? suggesionData?.netPrice : 0}</p>
                                        </div> */}
                                        <div className={classes.bottomPrice}>
                                            <p style={{ fontSize: '12px', color: '#545D68' }}>Total Price</p>
                                            <p className={classes.totalPrice}>${'publishedPrice' in suggesionData ? suggesionData?.publishedPrice : 0}</p>
                                        </div>
                                    </div>
                                    {
                                        suggesionData?.selected ?
                                            <button className={classes.sugButtonClear} onClick={() => { handleSuggested(suggesionData) }}>
                                                <CloseButtonSvg />
                                                Remove From Itinerary
                                            </button> :
                                            <button className={classes.sugButtonChoose} onClick={() => { handleSuggested(suggesionData) }}>
                                                Add to Itinerary
                                            </button>
                                    }
                                </div>
                            </div> :
                            <div className={classes.content}>
                                <div className={classes.contentStruct}>
                                    <p className={classes.para}> Overview </p>
                                    {(suggesionData && 'restaurant' in suggesionData && suggesionData?.restaurant?.description) || checkSpacing(suggesionData?.comment ? suggesionData?.comment : null) ?
                                        <>
                                            <div className={classes.comments}>{suggesionData && 'restaurant' in suggesionData && suggesionData?.restaurant?.description}</div>
                                            <div id="eventMonitor" className={classes.comments} dangerouslySetInnerHTML={{ __html: suggesionData?.comment ? suggesionData?.comment : "" }} >
                                            </div>
                                        </>
                                        : <div className={classes.comments} style={{ fontStyle: 'italic', fontWeight: '100', opacity: '0.5' }}>no description found</div>}

                                    <p className={classes.para}> Cancellation Policy </p>
                                    {suggesionData?.cancellationPolicy || checkSpacing(suggesionData?.cancellationPolicy ? suggesionData?.cancellationPolicy : null) ?
                                        <>
                                            <div id="eventMonitor" className={classes.comments} dangerouslySetInnerHTML={{ __html: suggesionData?.cancellationPolicy ? suggesionData.cancellationPolicy : '' }} >
                                            </div>
                                        </>
                                        : <div className={classes.comments} style={{ fontStyle: 'italic', fontWeight: '100', opacity: '1', fontSize: '20px' }}>No cancellation policy available</div>}

                                </div>
                                <div className={classes.contentStruct}>
                                    <p className={classes.para}> Details </p>
                                    <div className={classes.internal}><CalendarSvg width={"16"} height={"16px"} color={"#273443"} />Date : {moment.utc(suggesionData?.date).format('dddd, MMMM D, YYYY')} </div>
                                    <div className={classes.internal}><ClockSvg /> Start Time : {Helper.TimeConverter(suggesionData ? suggesionData.startTime : '')}</div>
                                    <div className={classes.internal}><DurationSvg /> Duration : {Helper.convertDecimalTime(suggesionData ? suggesionData.durationHours : 1)} </div>
                                    {/* <div className={classes.internal} style={{ alignItems: 'flex-start' }}><FlagSvg /> Meeting and Pickup : North Fields Coffee Tour, C. 506, Provincia de Alajuela, San Carlos, 21007, Costa Rica</div> */}

                                </div>
                                <div className={classes.bottomStruct} style={{ justifyContent: 'flex-end', marginRight: '10px' }}>
                                    {
                                        suggesionData?.selected ?
                                            <button className={classes.sugButtonClear} onClick={() => { handleSuggested(suggesionData) }}>
                                                <Close style={{ marginRight: "8px", color: "#FF3566", transform: "scale(0.8)" }} />
                                                Remove From Itinerary
                                            </button> :
                                            suggesionData && <button className={classes.sugButtonChoose} onClick={() => { handleSuggested(suggesionData) }}>
                                                Add to Itinerary
                                            </button>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActRest